import { useAutocompleteSource } from '@eas/common-web';
import { DictTaskNameAutocomplete } from '@models';
import { EvidenceApiUrl } from '@enums';

export function useTaskNames() {
  return useAutocompleteSource<DictTaskNameAutocomplete>({
    url: `${EvidenceApiUrl.DICT_TASK_NAME}/autocomplete`,
  });
}
